export const SUPERADMIN_TIER_ROLES = Object.freeze(["superadmin", "admin"]);
export const HOD_TIER_ROLES = Object.freeze(["hod", "manager", "marketing_manager"]);

export function normalizeRoleKey(role) {
  return String(role || "").trim().toLowerCase();
}

export function getOrgTier(role) {
  const r = normalizeRoleKey(role);
  if (SUPERADMIN_TIER_ROLES.includes(r)) return "superadmin";
  if (HOD_TIER_ROLES.includes(r)) return "hod";
  return "user";
}

export function isSuperAdminTier(role) {
  return SUPERADMIN_TIER_ROLES.includes(normalizeRoleKey(role));
}

export function isHodTier(role) {
  return HOD_TIER_ROLES.includes(normalizeRoleKey(role));
}

export function isUserTier(role) {
  return getOrgTier(role) === "user";
}

export const ORG_TIER_LABELS = {
  superadmin: "Super Admin",
  hod: "HOD",
  user: "User",
};
